import React from 'react';
import { ProfileInfoCard } from './components/ProfileInfoCard';
import { ProfileSocietyCard } from './components/ProfileSocietyCard';
import { ProfileSecurityCard } from './components/ProfileSecurityCard';
import { ProfilePreferencesCard } from './components/ProfilePreferencesCard';

export const ProfilePage: React.FC = () => {
  return (
    <div className="tw-p-6">
      <div className="tw-mb-6">
        <h1 className="tw-text-2xl tw-font-bold tw-text-gray-900">Mon profil</h1>
        <p className="tw-text-sm tw-text-gray-500 tw-mt-1">
          Gérez vos informations personnelles et vos préférences
        </p>
      </div>

      <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-6">
        {/* Colonne gauche */}
        <div className="tw-space-y-6">
          <ProfileInfoCard />
          <ProfileSocietyCard />
        </div>

        {/* Colonne droite */}
        <div className="tw-space-y-6">
          <ProfileSecurityCard />
          <ProfilePreferencesCard />
        </div>
      </div>
    </div>
  );
};
